import { useTimeseriesData } from './useTimeseriesData.js';
import { useTimeseriesFilteredData } from './useTimeseriesFilteredData.js';
import { useYAxisConfig } from './useYAxisConfig.js';
import { TimeseriesChartYAxisConfig } from '../types/timeseries-config.js';

export const useTimeseriesFilteredYAxis = (): TimeseriesChartYAxisConfig => {
  const { units: initialUnits } = useTimeseriesData();
  const { units, originalUnits } = useTimeseriesFilteredData();

  const [initialLeftUnit] = initialUnits;
  const [leftUnit] = units;
  const [originalLeftUnit] = originalUnits;
  const yAxis = useYAxisConfig();

  if (initialUnits.length === 1 && yAxis.right && !yAxis.left) {
    return { right: yAxis.right };
  }

  if (initialLeftUnit !== (originalLeftUnit ?? leftUnit)) {
    return { left: yAxis.right };
  }

  if (initialUnits.length !== units.length || units.length === 1) {
    return { left: yAxis.left };
  }

  return yAxis;
};
